import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MailingListItem } from '@/models'

type GetClientMailingListsRequest = {
  clientId: string
}

export const getClientMailingListsQueryKey = (data: GetClientMailingListsRequest) => [
  'useGetClientMailingLists',
  data,
]

const getClientMailingLists = async (
  data: GetClientMailingListsRequest,
): Promise<MailingListItem[]> => {
  const response = await authAPI.get<MailingListItem[]>(`/mailinglist/client/${data.clientId}`)
  return response.data
}

export const useGetClientMailingLists = (data: GetClientMailingListsRequest) =>
  useQuery({
    enabled: !!data.clientId,
    queryFn: () => getClientMailingLists(data),
    queryKey: getClientMailingListsQueryKey(data),
  })
